import { IHeActions } from "../../action-types/category/IHeActionType";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IHeReducer } from "../../reducer-model/category/IHeReducer";

const iniState: IHeReducer = {
    status: eReducerStatusBase.is_not_initialization,
    hes: []
};

export const heReducer = (state: IHeReducer = iniState, action: IHeActions): IHeReducer => {
    switch (action.type) {
        case "HE_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            };
        case "HE_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                hes: action.payload
            };
        case "HE_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "HE_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                heEditing: action.payload
            };
        case "HE_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            };
        case "HE_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            };
        case "HE_SAVE_SUCCESS":
            return {
                ...state,
                isShowEditModal: false,
                status: eReducerStatusBase.is_need_reload
            };
        case "HE_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "HE_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting
            };
        case "HE_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload
            };
        case "HE_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        default:
            return state;
    }
};
